import Home from "./home.vue";
import Menu from "./menu.vue";
import Intro from "./intro.vue";
import Base from "./base.vue";
import Story from "./story.vue";
import Answer from "./answer.vue";
import Test from "./test.vue";

export default [
    {
        path: "",
        component: Home,
        meta: { title: "セキュリティ基礎学習" },
    },
    {
        path: "/menu/:contents",
        component: Menu,
        meta: { title: "学習項目一覧" },
    },
    {
        path: "/intro/:contents",
        component: Intro,
        meta: { title: "イントロ" },
    },
    {
        path: "/base/:contents",
        component: Base,
        meta: { title: "基礎知識編" },
    },
    {
        path: "/story/:contents",
        component: Story,
        meta: { title: "ストーリー編" },
    },
    {
        path: "/answer/:contents",
        component: Answer,
        meta: { title: "解説編" },
    },
    {
        path: "/test/:contents",
        component: Test,
        meta: { title: "テスト編" },
    },
];
